import { action, computed, flow, makeObservable, observable } from 'mobx'

import { requestWrapper } from 'Shared/utils'

import { CustomGenerator } from 'Core/interfaces'
import { getDefaultStoreArrayValue, getDefaultStoreValue } from 'Core/utils'

import { Analytic } from 'Portals/Customer/entities'
import { DashboardRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'
import { powerBiConfigToLabelValue } from 'Portals/Customer/utils'

export class AnalyticStore {
	rootStore: RootStore

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
	}
	@observable accessor powerBiToken = getDefaultStoreValue<Analytic.Token.Response>()
	@observable accessor powerBiConfigs = getDefaultStoreArrayValue<Analytic.Basic>()
	@observable accessor currentChartId: Analytic.Form.Filter['chartId'] = null

	@action.bound
	setCurrentChartId(chartId: Analytic.Basic['id']) {
		this.resetConfig()
		this.currentChartId = chartId
	}

	@flow.bound
	*retrievePowerBiToken(): CustomGenerator<Analytic.Token.Response> {
		const { reportId, groupId, datasetId } = this.getCurrentConfig

		if (!reportId || !groupId || !datasetId) {
			return
		}

		yield requestWrapper({
			field: this.powerBiToken,
			repository: DashboardRepo.retrievePowerBiToken,
			repositoryParams: {
				reportId,
				datasetId,
				groupId
			}
		})
	}

	@flow.bound
	*retrievePowerBiConfigs(): CustomGenerator<Analytic.Basic[]> {
		yield requestWrapper({
			field: this.powerBiConfigs,
			repository: DashboardRepo.retrievePowerBiCharts,
			repositoryParams: null
		})
	}

	@computed
	get getCurrentConfig() {
		const currentPowerBiConfig = this.powerBiConfigs.value.find(
			(config) => config.id === this.currentChartId
		)
		return {
			reportId: currentPowerBiConfig?.chartReportId,
			groupId: currentPowerBiConfig?.chartGroupId,
			datasetId: currentPowerBiConfig?.chartDatasetId,
			token: this.powerBiToken.value?.token,
			expiration: this.powerBiToken.value?.expiration
		}
	}

	@computed
	get powerBiChartOptions() {
		return this.powerBiConfigs.value.reduce((acc, currentValue) => {
			if (currentValue.id && currentValue.description) {
				return [
					...acc,
					powerBiConfigToLabelValue({
						id: currentValue.id,
						description: currentValue.description
					})
				]
			}
			return acc
		}, [] as LabelValue<number>[])
	}

	@action.bound
	resetConfig() {
		this.currentChartId = null
		this.powerBiToken.value = null
	}
}
